import { render } from "./SkillsComponent.vue?vue&type=template&id=0f466164&scoped=true"
import script from "./SkillsComponent.vue?vue&type=script&lang=js"
export * from "./SkillsComponent.vue?vue&type=script&lang=js"

import "./SkillsComponent.vue?vue&type=style&index=0&id=0f466164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f466164"]])

export default __exports__